import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Form from '../../../components/PaymentForm/Form'
import Layout from "../../../components/layouts/Layout";
import { useForm } from "react-hook-form";
import LocalStorage from "../../../hook/LocalStorage";
import amx from '../../../assets/images/payment/amx.png'
import masterCard from '../../../assets/images/payment/mastercard.png'
import visa from '../../../assets/images/payment/visa.png'
import http from '../../../config/BaseUrl';
import { useEffect } from 'react';
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'

function PaymentCapture() {

  const { user } = LocalStorage();
  const history = useHistory()

  const { register, handleSubmit, formState: { errors }, setError } = useForm({ mode: "all", reValidateMode: "all" })
  const [loading, setLoading] = useState(false)
  const handleSubmitForm = (data) => {
    const formData = {
      cardNumber: data.cardNumber,
      cardholderName: data.cardholderName,
      cvvNumber: data.cvvNumber,
      expiryMonth: data.expiryMonth,
      expiryYear: data.expiryYear,
      user_id: user.id,
      user_email: user.email,
      submittedData: history.location.state.item
    }
    try {
      http.post('data-capture-payment', formData).then((res) => {
        if (res) {
          history.push('/data-capture/payment/success')
        }

      }).then((err) => {

      })
    } catch (error) {

    }
  }

  return (
    <div className="section-authentication-login p-md-0 p-3">
      <div className="container-fluid px-0">

        <div className="row h-100">
          <div className="col-md-6 d-none d-md-block">
            <div className="page-image">
              <div className="login-header mt-5">
                <div className="logo">
                  <img src={Logo} className="img-fluid" alt="haylo" />
                </div>
              </div>
              <div className="image-body">
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="form-body">
              <div className="row justify-content-center align-items-center h-100">
                <div className="col-md-10 col-lg-10 col-xl-6 col-sm-8 col-12">
                  <div className="payment-form">
                    <div className="payment-form-body">
                      <form onSubmit={handleSubmit(handleSubmitForm)}>
                        <div className="text-center form-header border-bottom payment-form-header">
                          <h4 className="text-secondary text-uppercase">Card Information</h4>
                          <div className="payment-images">
                            <div className="card-item">
                              <img src={visa} className="img-fluid" alt="visa" />
                            </div>
                            <div className="card-item">
                              <img src={masterCard} className="img-fluid" alt="masterCard" />
                            </div>
                            <div className="card-item">
                              <img src={amx} className="img-fluid" alt="amx" />
                            </div>
                          </div>
                        </div>
                        <Form register={register} errors={errors} />
                        <div id="addExistBtn">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                              : (" Purchase Data")
                            }
                          </button>
                        </div>
                      </form>
                    </div>

                    <div className="payment-page-footer">
                      <p onClick={() => history.goBack()} className="text-primary" style={{ cursor: 'pointer' }}>Back To Previous Page</p>
                    </div>

                  </div>



                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
  )
}

export default PaymentCapture
